/* document.addEventListener('DOMContentLoaded', function () {
  var modal = document.getElementById('custom-modal');
  var sizeChartLink = document.querySelector('.size-chart-link');
  var closeButton = document.querySelector('.close');
  var sizeChartContent = document.getElementById('size-chart-content');

  // Show the modal
  function showModal() {
    modal.style.display = 'block';
  }

  // Close the modal
  function closeModal() {
    modal.style.display = 'none';
  }

  // Close the modal when clicking the close button
  closeButton.addEventListener('click', closeModal);

  // Close the modal when clicking outside of it
  window.addEventListener('click', function (event) {
    if (event.target === modal) {
      closeModal();
    }
  });

  // Open the modal when the "Size Chart" link is clicked
  sizeChartLink.addEventListener('click', function (e) {
    e.preventDefault();
    showModal();
  });

  // Example: Close the modal after a certain time (adjust as needed)
  setTimeout(function () {
    closeModal();
  }, 5000); // Close after 5 seconds (for demonstration purposes)
}); */
/* document.addEventListener('DOMContentLoaded', function () {
  var openModalBtn = document.getElementById('openModalBtn');
  var modal = document.getElementById('modal');
  var closeModalBtn = document.getElementById('closeModalBtn');

  // Open the modal
  openModalBtn.addEventListener('click', function () {
    modal.style.display = 'block';
  });

  // Close the modal when clicking the close button
  closeModalBtn.addEventListener('click', function () {
    modal.style.display = 'none';
  });

  // Close the modal when clicking outside of it
  window.addEventListener('click', function (event) {
    if (event.target === modal) {
      modal.style.display = 'none';
    }
  });
});
*/

document.addEventListener("DOMContentLoaded", function () {
  var openModalBtn = document.getElementById("sizechartLink");
  var modal = document.getElementById("modal");
  var closeModalBtn = document.getElementById("closeModalBtn");

  function openModal() {
    modal.style.display = "block";
    document.body.style.overflow = "hidden"; // Prevent scrolling when modal is open
  }

  // Function to close the modal
  function closeModal() {
    modal.style.display = "none";
    document.body.style.overflow = ""; // Re-enable scrolling when modal is closed
  }

  // Event listener with preventDefault for the clickable text
  openModalBtn.addEventListener("click", function (event) {
    event.preventDefault(); // Prevent the default behavior of the element
    openModal();
  });

  closeModalBtn.addEventListener("click", closeModal);

  modal.addEventListener("click", function (event) {
    // Close modal if the overlay is clicked
    if (event.target === modal) {
      closeModal();
    }
  });
});
